import styles from './FilterOptions.module.scss';
import { TEXT_WEIGHT, TTableFilterItem } from '@types';
import {
	FilterString,
	FilterRange,
	FilterSelectMultiple,
	FilterSelect,
	FilterDate,
	FilterLocation,
	FilterBoolean,
	FilterAssignedToMe,
	FilterShipperLookup,
	FilterUserLookup,
	FilterCarrierLookup,
	FilterSelectMultipleGroup,
	FilterCustomPartialExpired,
	FilterSelectGroup,
	FilterMultipleBoolean,
	FilterTimeRange,
	FilterRegion,
	FilterRadio,
	FilterSelectSingle,
	FilterCustomPartialContainsDangerousGoods,
	FilterTypeAhead,
} from './FilterOptions/index';
import FilterRateCardLane from './FilterOptions/FilterRateCardLane';
import { Label } from '@components';

export type OptionProps = {
    meta: any;
    header: string;
    canFilter: boolean;
    filterData: any;
    update: (key:string, val: TTableFilterItem | null) => void;
    columnId: string;
}

export const FilterOption = (props:OptionProps) => {
	const {
		meta,
		header,
		canFilter,
		filterData,
		update,
		columnId
	} = props;
	if (!meta) return null;

	const dataType = meta?.dataType;
	const fullName = meta?.columnFullName;
	const filterType = meta?.filterOptions?.type ?? 'string';

	const onChange = (v: TTableFilterItem | null) => {
		update(columnId, v);
	}
	const showTitle = () => {
		return !['location', 'selectMultiple', 'boolean', 'assignedToMe', 'selectGroup', 'selectMultipleGroup'].includes(filterType);
	}
	const isFieldLookUp = () => {
		return ['shipperLookup', 'carrierLookup', 'userLookup'].includes(filterType);
	}
	const clearFilter = () => {
		onChange(null);
	}

	return (dataType === undefined || dataType === 'data') && canFilter ? <div className={styles.filterOption}>
		{
			showTitle() && <div className={styles.filterLabel}>
				<Label weight={TEXT_WEIGHT.SEMI_BOLD} text={fullName !== undefined ? fullName : header} />
				{(filterData && isFieldLookUp()) && <button className={styles.clearBtn} onClick={() => { clearFilter() }}>Clear</button>}
			</div>
		}
		{filterType === 'boolean' && <FilterBoolean meta={meta} header={header} filterData={filterData} onChange={onChange} />}
		{filterType === 'multipleBoolean' && <FilterMultipleBoolean meta={meta} header={header} filterData={filterData} onChange={onChange} />}
		{filterType === 'assignedToMe' && <FilterAssignedToMe meta={meta} header={header} filterData={filterData} onChange={onChange} />}
		{filterType === 'string' && <FilterString meta={meta} header={header} filterData={filterData} onChange={onChange} />}
		{filterType === 'range' && <FilterRange meta={meta} header={header} filterData={filterData} onChange={onChange} />}
		{filterType === 'timerange' && <FilterTimeRange meta={meta} header={header} filterData={filterData} onChange={onChange} />}
		{filterType === 'selectMultiple' && <FilterSelectMultiple meta={meta} header={header} filterData={filterData} onChange={onChange} />}
		{filterType === 'selectGroup' && <FilterSelectGroup meta={meta} header={header} filterData={filterData} onChange={onChange} />}
		{filterType === 'select' && <FilterSelect meta={meta} header={header} filterData={filterData} onChange={onChange} />}
		{filterType === 'selectSingle' && <FilterSelectSingle meta={meta} header={header} filterData={filterData} onChange={onChange} />}
		{filterType === 'date' && <FilterDate meta={meta} header={header} filterData={filterData} onChange={onChange} />}
		{filterType === 'location' && <FilterLocation meta={meta} header={header} filterData={filterData} onChange={onChange} />}
		{filterType === 'region' && <FilterRegion meta={meta} header={header} filterData={filterData} onChange={onChange} />}
		{filterType === 'rateCardLane' && <FilterRateCardLane meta={meta} header={header} filterData={filterData} onChange={onChange} />}
		{['shipperLookup', 'shipperLookupExternalId'].includes(filterType) && <FilterShipperLookup filterType={filterType} meta={meta} header={header} filterData={filterData} onChange={onChange} />}
		{['carrierLookup', 'carrierLookupExternalId'].includes(filterType) && <FilterCarrierLookup filterType={filterType} meta={meta} header={header} filterData={filterData} onChange={onChange} />}
		{filterType === 'userLookup' && <FilterUserLookup meta={meta} header={header} filterData={filterData} onChange={onChange} />}
		{filterType === 'customPartialExpired' && <FilterCustomPartialExpired meta={meta} header={header} filterData={filterData} onChange={onChange} />}
		{filterType === 'selectMultipleGroup' && <FilterSelectMultipleGroup meta={meta} header={header} filterData={filterData} onChange={onChange} /> }
		{filterType === 'radio' && <FilterRadio meta={meta} header={header} filterData={filterData} onChange={onChange} /> }
		{filterType === 'customPartialContainsDangerousGoods' && <FilterCustomPartialContainsDangerousGoods meta={meta} header={header} filterData={filterData} onChange={onChange} />}
		{filterType === 'typeAhead' && <FilterTypeAhead meta={meta} header={header} filterData={filterData} onChange={onChange} /> }
		{(filterData && !isFieldLookUp()) && <button className={styles.clearBtn} onClick={() => { clearFilter() }}>Clear</button>}
	</div> : null;
}
